<template>
  <div
    v-if="totalQuantity"
    class="px-5 h-18"
  >
    <div class="relative mt-6 flex justify-between text-sm text-center whitespace-nowrap cursor-default select-none">
      <div
        class="w-6 h-6 rounded-full bg-white border border-green-400 flex-center z-10"
        @dblclick="store.reset"
      >
        0
      </div>
      <div
        v-for="size in bundleSizes"
        :key="size"
        class="w-6 h-6 rounded-full bg-white border border-green-400 flex-center transition-all z-10"
        :class="{ active: size === totalQuantity }"
      >
        {{ size }}
      </div>
      <div
        class="absolute left-1 right-3 top-2 bg-gray-100 rounded-md h-2 z-0">
        <div
          class="relative bg-green-500 rounded-md h-2 z-0 min-w-6 transition-all"
          :style="{ width: progress }"
        />
      </div>
    </div>
      <!-- <div
        v-for="i in store.MAX_SIZE"
        :key="i"
        :title="String(i)"
        class="relative rounded-full w-2 h-2"
        :class="i < totalQuantity ? 'bg-green-400' : 'bg-gray-300'"
      >
        <div
          class="absolute -top-2 -left-2 w-6 h-6 rounded-full bg-white font-semibold border border-green-400 flex-center z-20 transition-all duration-100 ease-out"
          :class="totalQuantity === i ? 'scale-100 opacity-100' : 'scale-0 opacity-0'"
        >
          {{ totalQuantity }}
        </div>
        <template v-if="i === store.MIN_SIZE">
          <div
            class="absolute -top-2.5 -left-2.5 w-7 h-7 rounded-full bg-green-500 text-white contrast-more:text-black font-semibold border border-green-100 flex-center transition-transform duration-200 ease-out"
            :class="totalQuantity === store.MIN_SIZE ? 'scale-125 z-30' : 'z-10'"
            @dblclick="setItemsUrl"
          >
            {{ store.MIN_SIZE }}
          </div>
          <div
            class="absolute top-5 -left-5 w-10 text-xs"
            :class="totalQuantity === store.MIN_SIZE ? 'text-green-500' : 'text-gray-500'"
          >
            {{ $t('bundler.minimum') }}
          </div>
        </template>
        <template v-if="i === store.MAX_SIZE">
          <div
            class="absolute -top-2.5 -left-2 w-7 h-7 rounded-full bg-green-500 text-white contrast-more:text-black font-semibold border border-green-100 flex-center transition-transform duration-200 ease-out"
            :class="totalQuantity === store.MAX_SIZE ? 'scale-125 z-30' : 'z-10'"
            @dblclick="setItemsUrl"
          >
            {{ store.MAX_SIZE }}
          </div>
          <div
            class="absolute top-5 -right-3 text-xs"
            :class="totalQuantity === store.MAX_SIZE ? 'text-green-500' : 'text-gray-500'"
          >
            {{ $t('bundler.best_value') }}
          </div>
        </template>
      </div>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useBundleStore } from '@/stores'
// import { setUrlParams } from '@/utils'
const store = useBundleStore()
const { bundleType, bundleSizes, MIN_SIZE, MAX_SIZE } = store
const { totalQuantity } = storeToRefs(store)

const toPercent = (n: number) => `${Math.round(n * 100)}%`

const progress = computed(() => {
  const { value } = totalQuantity
  if (bundleType === 'coffee') {
    return toPercent(value / MAX_SIZE)
  } else {
    if (value <= MIN_SIZE) {
      return toPercent(value / (MIN_SIZE * bundleSizes.length)) // get to 33%
    }
    return toPercent((value / (MAX_SIZE - 8)) - (1 / bundleSizes.length))
  }
})
// const setItemsUrl = () => {
//   const items = store.getEncodedItems()
//   setUrlParams({ items })
// }
</script>

<style scoped>
.active {
  @apply border-green-500 bg-green-500 text-white scale-125 shadow-md;
}
</style>
